<template>
  <div class="company-tree-view">

    <!--    todo bring popup here -->
    <!--    <transition name="userpopupdash">-->
    <!--      <div :class="'type-'+popupType" id="popup-wrapper" v-if="popupShown">-->
    <!--        <team-form v-if="popupType='team'" @closePopup="closePopup" :team="activeTeam"></team-form>-->
    <!--      </div>-->
    <!--    </transition>-->
    <div class="header">
      <div class="mb-2 team-overview-title d-flex align-items-baseline">
        <h2 class="mb-0">
          {{ $t('message.team_overview') }}
        </h2>

        <!--        <div class="col flat-date-pickr">-->
        <!--          <div class="row-flex flex-v">-->
        <!--            <input type="date"-->
        <!--                   v-model="treeDate"-->
        <!--                   :max="today"-->
        <!--                   class="ml-1 mb-0 styled-input c_date_picker form-control">-->
        <!--          </div>-->
        <!--        </div>-->
        <!--        <div v-if="treeType === 'hr'">-->
        <!--          <button class="btn" @click.prevent.stop="$emit('createTeam')">+ {{ $t('message.add_team') }}-->
        <!--          </button>-->
        <!--        </div>-->
      </div>
      <!--      <button @click="generateTreeSnapshot">save tree snapshot to archive</button>-->
      <company-tree-filter ref="treefilter" @filterHandler="filterHandler" :tree="baseTree"></company-tree-filter>
    </div>
    <div class="spinner text-center"
         v-show="loading">
      <i class="fa-3x fas fa-circle-notch fa-spin"></i>
    </div>
    <span class="tree_buttons_left">
          <button v-if="!expandToggle" class="btn p-0 btn-sm" @click.prevent="toggleTeamMembers($event,true)">
            <i class="fal fa-sitemap"></i>
            {{ $t('message.expand_all') }}
          </button>
            <button v-else class="btn p-0 btn-sm" @click.prevent="toggleTeamMembers($event,false)">
            <i class="fal fa-sitemap"></i>
            {{ $t('message.collapse_all') }}
          </button>
        </span>
    <span class="tree_buttons">
      <button v-if="treeType === 'hr' && !loading" class="p-0 btn createteam" @click.prevent.stop="$emit('createTeam')">+
      {{ $t('message.add_team') }}
    </button>
    </span>

    <div v-show="!loading" class="tf-tree team-tree">
      <!--      <div  class="ml-auto d-inline-block">-->

      <!--      </div>-->
      <!--      editing: {{editing}}-->
      <ul
        :data-filtering="false">
        <!--       <pre class="text-left text-white"> {{filteredTree}}</pre>-->

        <team-tree v-if="showTree"
                   @getTeam="getTeam"
                   @getUser="getUser"
                   @clickedTeam="clickedTeam"
                   :editing="editing"
                   :data-company="true"
                   :status="true"
                   :tree-type="treeType"
                   :filtering="filtering"
                   ref="maintree"
                   :team="filteredTree">

        </team-tree>
      </ul>
    </div>
  </div>
</template>
<script>
import store from "../../store/store";
import CompanyTreeFilter from "./CompanyTreeFilter";
import TeamTree from "./TeamTree";
import TeamForm from "../Teams/TeamForm";
import moment from 'moment'
import qs from 'qs';
// import { nextTick } from 'vue';


export default {
  components: {
    TeamForm,
    CompanyTreeFilter,
    TeamTree
  },
  created() {
    if (this.treeType === 'hr') {
      this.editing = true
    }
    // this.initTree(this.treeType === 'hr'); //refetch tree always if HR, todo: only refetch if changed
  },
  mounted() {
    // console.log('mounted tree')
    this.isTreeModified()
  },
  data() {
    return {
      showTree: true,
      expandToggle: false,
      loading: true,
      editing: false,
      treeDate: moment().format('YYYY-MM-DD'),
      popupShown: false,
      activeTeam: null,
      filtering: false,
      baseTree: {},
      filteredTree: {},
      todayTree: {},
    }
  },
  props: {
    treeType: { // 'manager' or 'hr'
      type: String,
      default() {
        return 'manager'
      }
    }
  },
  watch: {
    treeDate() {
      //  console.log('tree date change', this.treeDate)
      this.loadArchivedTree()
    }
  },
  methods: {
    toggleTeamMembers(evt, e = true) {
      this.expandToggle = e;
      this.toggleMembers(this.$refs.maintree, e)
    },
    toggleMembers(team, status) {
      team.showMembers = status;
      if (status) {
        team.showChildren = status;
      }
      team.$nextTick(() => {
        for (let key in team.$refs) {
          if (team.$refs.hasOwnProperty(key)) {
            if (team.$refs[key].length > 0) {
              this.toggleMembers(team.$refs[key][0], status)
            }
          }
        }
      })
    },
    loadArchivedTree() {
      if (this.treeDate === this.today) {
        if (this.treeType === 'hr') {
          this.editing = true;
          this.baseTree = store.getters.getTree;
          this.filteredTree = store.getters.getTree;
        } else {
          this.editing = false;
          this.baseTree = store.getters.getManagerTree;
          this.filteredTree = store.getters.getManagerTree;
        }
      } else {
        this.editing = false;
        this.axios.get('/archivedtrees?date=' + this.treeDate + '&_sort=date:DESC&_limit=1').then(r => {
          if (r.data.length) {
            this.baseTree = r.data[0].tree;
            this.filteredTree = r.data[0].tree;
            this.$forceUpdate();
          }
        })
      }
    }
    ,
    generateTreeSnapshot(event, tree = this.baseTree, date = moment().format('YYYY-MM-DD')) {
      this.axios.post('/archivedtrees', {
        tree: JSON.stringify(tree),
        date: date
      }).then(r => {
      }).catch(r => {
      })
    }
    ,
    async fetchChangesAfterNow() {
      const modifiedLogs = [
        'Tree modified',
        'Created user',
        'Created team',
        'Edited company',
        'Edited user',
        'Edited team',
        'Deleted team',
        'Added team member',
        'Removed team member',
      ];

      const date = this.treeType === 'hr' ? store.getters.getTreeTimestamp : store.getters.getManagerTreeTimestamp

      if (!date) {
        this.initTree(true)
      }
      let ts = date

      let qparams = []

      modifiedLogs.forEach(action => {
        qparams.push([
          {action_in: action},
          {created_at_gt: ts}
        ])
      })

      const query = qs.stringify({
        _where: {
          _or: qparams
        }
      })

      return await this.axios.get('/activitylogs?' + query);
    }
    ,
    async isTreeModified() {
      // this.initTree(true)

      let modified = false;
      let cachedTree = null;
      if (this.treeType === 'manager') {
        cachedTree = store.getters.getManagerTree
      } else {
        cachedTree = store.getters.getTree
      }
      if (cachedTree) {
        // console.log('found cached tree')
        const l = await this.fetchChangesAfterNow();
        const logsChanged = (l.data.length > 0);
        modified = logsChanged;
        this.initTree(logsChanged)
      } else {
        modified = true;
        this.initTree()
      }
    }
    ,
    scrollTreeInView() {
      const el = document.querySelector('.company-tree-view > .tf-tree.team-tree');
      setTimeout(() => {
        el.scrollTo((el.scrollWidth - el.clientWidth) / 2, 0)
      }, 100)
    }
    ,
    async fetchTree() {
      // console.log('fetching tree')
      this.loading = true;
      let ep = '/teams';
      const tree = await this.axios.get(ep);
      const data = tree.data
      this.baseTree = data[0];
      this.todayTree = data[0];
      this.filteredTree = data[0];
      if (this.treeType === 'manager') {
        store.dispatch('setManagerTree', data[0])
      } else {
        store.dispatch('setTree', data[0])
      }
      this.scrollTreeInView();
      this.loading = false;
    }
    ,
    initTree(refetch = false) {
      // console.log('initializing tree')
      const storeTree = this.treeType === 'manager' ? store.getters.getManagerTree : store.getters.getTree

      if (refetch) {
        this.fetchTree();
        return;
      }
      if (storeTree) {
        this.baseTree = storeTree;
        this.filteredTree = storeTree;
        this.scrollTreeInView();
        this.loading = false;
      } else {
        this.fetchTree();
      }
    }
    ,
    filterHandler(response) {
      this.filtering = !response[1];
      this.filteredTree = response[0]
    }
    ,
    moveCallback(evt) {
      let uid = evt.dragged.dataset.uid;
      let targetUids = [];
      const targetMembers = evt.to.children;

      for (var i = 0; i < targetMembers.length; i++) {
        targetUids.push(targetMembers[i].dataset.uid);
      }

      if (targetUids.includes(uid)) {
        return false;
      }
    }
    ,
    endUserDrag(e) {
      let uid = e.item.dataset.uid;
      let movedToTeamEl = e.to;
      let to_id = movedToTeamEl.dataset.parentid;
      this.moveUser(uid, to_id)
    }
    ,
    addUserToTeam(uid, t_id) {
      // let team = null;
      // this.axios.get('/teams/' + t_id).then(res => {
      //   team = res.data;
      //   let members = team.users;
      //   if (!members.includes(uid)) {
      //     members.push(uid);
      //     this.axios.put('/teams/' + t_id, {
      //       users: members
      //     }).then(res => {
      //       this.logActivity('Removed team member', 'info (HR)');
      //     })
      //   }
      // });
    }
    ,
    clickedTeam(team) {
      // console.log('clicked team in company tree', team)
      this.axios.get('/teams/' + team.id).then(r => {
        this.$emit('clickedTeam', r.data)
      })


    }
    ,
    moveUser(uid, to_id) {
      this.addUserToTeam(uid, to_id);
    }
    ,
    createTeam() {
      this.activeTeam = {parent: null};
      this.popupShown = true;
      this.popupType = 'team';
    }
    ,
    dragging(b) {
      this.dragActive = b;
    }
    ,
    getUser(user) {
      // console.log('getting user company tree');
      this.activeUser = user;
      this.popupShown = true;
      this.popupType = 'user';
      this.$emit('getUser', user)

      // this.axios.get('/users/' + id).then(users => users.data)
      //   .then(res => {
      //     const data = res;
      //     this.activeUser = data;
      //     this.popupShown = true;
      //     this.popupType = 'user';
      //   })
    }
    ,
    getTeam(team) {
      // console.log('team',team)
      this.activeTeam = team;
      this.popupShown = true;
      this.popupType = 'team';
      this.$emit('getTeam', team)
    }
    ,
    closePopup() {
      this.popupShown = false;
      this.popupType = '';
    }
    ,
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Tree/CompanyTree.vue